import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { FormControl, Button } from 'react-bootstrap';
import { post } from '../../service/index';
import Responsive from 'react-responsive';
import './Login.css';
import './LoinMobile.scss';
// redux
import { connect } from 'react-redux';
import { setLogin, setUser } from '../../redux/login/actions';

import swal from 'sweetalert';
const Desktop = (props) => <Responsive {...props} minWidth={768} />;
const Mobile = (props) => <Responsive {...props} maxWidth={766} />;

class Login extends Component {
	constructor(props) {
		super(props);

		this.state = {
			username: '',
			password: ''
		};
	}

	componentDidMount = () => {
		if (this.props.login.isLogin) {
			this.props.history.push('/');
		}
	};

	render() {
		return (
			<div className="login-page-container">
				<div className="left ">
					<div className="d-flex">
						<div style={{ padding: '10.19px' }} className="d-flex">
							<div className="row">
								<div className="row">
									<div className="col-xl-6 d-flex col-md-6 col-6">
										<div style={{ width: '15%', margin: '10px' }}>
											<img src={require('../../assets/image/logo_khonkaen.png')} alt="logo_kkc" />
										</div>
										<div style={{ width: '50%', margin: '10px', objectFit: 'cover' }}>
											<img
												src={require('../../assets/image/logo_projectsoft.png')}
												alt="logo_ps"
											/>
										</div>
									</div>
									<div
										className="col-xl-6 col-md-6 d-flex col-6"
										style={{ padding: '0', margin: '0', justifyContent: 'center' }}
									>
										<div style={{ width: '15%', margin: '10px' }}>
											<img src={require('../../assets/icon/facebook.png')} alt="logo_facebook" />
										</div>

										<div style={{ width: '15%', margin: '10px' }}>
											<img src={require('../../assets/icon/login_web.png')} alt="login_web" />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="right">
					<div className="container-login">
						<div className="epam-logo">
							<img src={require('../../assets/image/logo_login.png')} alt="etam" />
						</div>
						<h2>ยินดีต้อนรับ</h2>
						<p className="textstyle">เข้าสู่ระบบ</p>
						<div className="field">
							<div className="control has-icons-left">
								<FormControl
									className="input login  textstyle"
									style={{ border: 'none' }}
									placeholder="ชื่อผู้ใช้"
									onChange={this._onChange}
									type="text"
									name="username"
								/>

								<span className="icon is-small is-left">
									<img
										src={require('../../assets/icon/username1.png')}
										alt="login-icon"
										className="login-icon"
									/>
								</span>
							</div>
						</div>
						<div className="field" id="password">
							<div className="control has-icons-left">
								<FormControl
									className="input login textstyle"
									style={{ border: 'none' }}
									placeholder="รหัสผ่าน"
									onChange={this._onChange}
									type="password"
									name="password"
								/>

								<span className="icon is-small is-left">
									<img
										src={require('../../assets/icon/password1.png')}
										className="login-icon"
										alt="login-icon"
									/>
								</span>
							</div>
						</div>
						<div className="btn_container">
							<Button className="button login buttonfont " type="submit" onClick={this._handleLogin}>
								เข้าสู่ระบบ
							</Button>
						</div>
					</div>
					<div />
				</div>
			</div>
		);
	}

	_onChange = (event) => this.setState({ [event.target.name]: event.target.value });

	// handle login
	_handleLogin = async () => {
		try {
			const { username, password } = this.state;
			if (username && password) {
				const login = await post('/user/login', { username, password });
				console.log('login success');
				this.props.setUser(login);
				this.props.setLogin(true);
				this.props.history.push('/');
			} else {
				swal('ล็อคอินผิดพลาด', 'กรุณากรอก ชื่อผู้ใช้ และ รหัสผ่านให้ครบถ้วน', 'error');
			}
		} catch (err) {
			console.log(err);
			swal('ล็อคอินผิดพลาด', err, 'error');
		}
	};
}

const mapStateToProps = (state) => ({
	login: state.login
});

const mapDispatchToProps = (dispatch) => ({
	setLogin: (payload) => dispatch(setLogin(payload)),
	setUser: (payload) => dispatch(setUser(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/pages/Login/Login.js